<button 
  (click)="onClick()"
  class="relative bg-white rounded-xl border-neutral-gray-200 border-2 border-solid px-4 py-3 flex items-center gap-3 hover:shadow-md transition-shadow w-full"
>
  <!-- Pill "Nuevo" si es necesario -->
  <ds-pill-soon 
    *ngIf="data().showPill"
    [textValue]="data().pillText || 'Nuevo'"
    [animationValue]="'swing'"
    [backgroundColorValue]="'bg-cantera-red-stepper'"
    [textColorValue]="'text-white'"
    [sizeValue]="'medium'"
    class="absolute -top-2 -left-2 z-10"
  ></ds-pill-soon>

  <!-- Icono -->
  <img 
    [src]="data().iconSrc" 
    [alt]="data().title" 
    class="w-10 h-10 object-contain flex-shrink-0" 
  />

  <!-- Título -->
  <span class="text-neutral-gray-900 font-poppins text-base font-semibold flex-1 text-left">
    {{ data().title }}
  </span>

  <!-- Flecha derecha -->
  <app-svg-icon 
    [iconName]="SvgIcon.CHEVRON_RIGHT" 
    [size]="24" 
    class="flex-shrink-0"
  ></app-svg-icon>
</button>